import * as React from 'react';
import { useContext } from 'react';

import type { NaptimeThirdPartyOrganizationFromSlugFragment } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramBySlugQuery';

const EnterpriseThirdPartyOrganizationContext = React.createContext<
  NaptimeThirdPartyOrganizationFromSlugFragment | undefined
>(undefined);

/**
 * @description Hook to get the third party organization general information
 */
export const useThirdPartyOrganization = () => {
  const thirdPartyOrganization = useContext(EnterpriseThirdPartyOrganizationContext);

  return thirdPartyOrganization;
};

export default EnterpriseThirdPartyOrganizationContext;
